import { render, staticRenderFns } from "./BannerSection.vue?vue&type=template&id=63367dea&scoped=true&"
import script from "./BannerSection.vue?vue&type=script&lang=js&"
export * from "./BannerSection.vue?vue&type=script&lang=js&"
import style0 from "./BannerSection.vue?vue&type=style&index=0&id=63367dea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63367dea",
  null
  
)

export default component.exports